export default __webpack_public_path__ + "static/media/invoice-red.861f7cff.svg";